import { Signal } from "../../essentials/Signal";

export const onOpenMikebot = new Signal<string | null>();
